import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { HandleStudentsWithoutRegisteringApp } from 'domain/usecases';

interface IStudentsWithoutRegisteringApp {
  studentsWithoutRegisteringApp: HandleStudentsWithoutRegisteringApp.Result;
}

interface IPayloadData
  extends PayloadAction<HandleStudentsWithoutRegisteringApp.Result> {}

const initialState: IStudentsWithoutRegisteringApp = {
  studentsWithoutRegisteringApp: null,
};

export const StudentsWithoutRegisteringApp = createSlice({
  name: 'students-without-registering-app',
  initialState,
  reducers: {
    loadStudentsWithoutRegisteringApp: (state, action: IPayloadData) => {
      state.studentsWithoutRegisteringApp = action.payload;
    },
    clearStudentsWithoutRegisteringApp: (state) => {
      state.studentsWithoutRegisteringApp = null;
    },
  },
});

export const {
  loadStudentsWithoutRegisteringApp,
  clearStudentsWithoutRegisteringApp,
} = StudentsWithoutRegisteringApp.actions;

export default StudentsWithoutRegisteringApp.reducer;
